import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Route, Router } from '@angular/router';
import { AdminHTTPService } from '@services/datasources/admin-http-service';
import { FeatureService } from '@services/features/feature.service';
import { UserInfoDto } from 'app/@types/dto/user-info-dto.model';
import { BehaviorSubject, filter, Subject, takeUntil } from 'rxjs';

interface UserInfoListEntry extends UserInfoDto {
    index: number;
    selected: boolean;
    fullname: string;
}
@Injectable({
    providedIn: 'root',
})
export class AdminDataSyncService implements OnDestroy {
    private destroy$ = new Subject<void>();
    private isDataLoaded = false;

    constructor(
        private AdminHttpService: AdminHTTPService,
        private featureService: FeatureService,
        private router: Router,
    ) {
        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                takeUntil(this.destroy$),
            )
            .subscribe((e) => {
                if (
                    this.featureService.hasUiFeatures(['admin_admin'], false) ||
                    this.featureService.hasUiFeatures(['admin_admin'], true)
                ) {
                    this.getData(this.dedicatedAdmins.getValue() !== undefined && this.dedicatedAdmins.getValue().length>0);
                    this.isDataLoaded = true;
                    
                }
            });
    }
    //dedicatedAdmin Signals
    public udpateListSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public updateTitleSubject: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);
    public currentSelectedOrgId: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(
        undefined,
    );

    public dedicatedAdmins: BehaviorSubject<UserInfoListEntry[]> = new BehaviorSubject<UserInfoListEntry[]>([]);

    //admin Signals
    public udpateDedicatedAdminListSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public currentSelectedDedicatedAdminId: BehaviorSubject<string | undefined> = new BehaviorSubject<
        string | undefined
    >(undefined);
    public updateDedicatedAdminNameSubject: BehaviorSubject<string | undefined> = new BehaviorSubject<
        string | undefined
    >(undefined);

    public loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public resetSelection() {
        this.updateTitleSubject.next(undefined);
        this.currentSelectedOrgId.next(undefined);
        this.updateDedicatedAdminNameSubject.next(undefined);
        this.currentSelectedDedicatedAdminId.next(undefined);
        this.udpateListSubject.next(true);
        this.udpateDedicatedAdminListSubject.next(true);
        this.loading.next(false);
    }
    getData(hideLoader?: boolean) {
        if(hideLoader === undefined || hideLoader === false) this.loading.next(true);
        this.AdminHttpService.getDedicatedAdminList().subscribe({
            next: (adminResponse) => {
                if (!adminResponse || adminResponse.length === 0) {
                    console.warn('No dedicated admins found in response');
                    this.dedicatedAdmins.next([]);
                    this.loading.next(false);
                    return;
                }

                const admins: UserInfoListEntry[] = adminResponse.map((p, i) => {
                    const currentSelectedDAdminId = this.currentSelectedDedicatedAdminId.getValue();
                    return {
                        ...p,
                        fullname: `${p.firstname} ${p.lastname}`,
                        uid: p.uid ?? '',
                        index: i,
                        selected: currentSelectedDAdminId === p.uid,
                    } as UserInfoListEntry;
                });

                const sortedAdmins = admins.sort((a, b) => {
                    return a.fullname.localeCompare(b.fullname);
                });

                this.dedicatedAdmins.next(sortedAdmins);

                // Only set the current selected admin if none is selected
                if (!this.currentSelectedDedicatedAdminId.getValue() && sortedAdmins.length > 0) {
                    this.currentSelectedDedicatedAdminId.next(sortedAdmins[0].uid);
                }

                this.loading.next(false);
            },
            error: (error) => {
                console.error('Error loading dedicated admins:', error);
                this.dedicatedAdmins.next([]);
                this.loading.next(false);
            },
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
